import { Check, StarOutlineSharp, StarSharp, Add, Close, Dashboard, Cases, MedicalInformation, MedicalInformationOutlined, Help, LabelImportant, NotificationImportant, CalculateOutlined, Update, NotificationImportantOutlined, NotificationsActiveOutlined, Money, MoneyOutlined, MoreTime, Receipt, GavelRounded, CloseOutlined } from "@mui/icons-material";
import { Activity, FileText, Folder, Home, User, Settings, Bell, Calendar, Clipboard, Cloud, Code, DollarSign, Edit, Eye, File, Heart, Image, Lock, Mail, MapPin, MessageCircle, Phone, Shield, ShoppingCart, Star, Tag, Trash, Truck, Users, Video, Section, SectionIcon, LucideSection, TrashIcon, Eraser, Edit2, Trash2, Archive, Briefcase, BriefcaseBusiness, ShieldCheck, Banknote, CreditCard, Handshake, CheckCheck, HandCoins, ReceiptIcon, Link, Clock, ClockAlert, Search, ArrowUp, ArrowUpDown, BookX, FileStack, BookUser, UserSearch, EqualApproximately, ArrowUpRight, FilePlus2, GavelIcon, BriefcaseBusinessIcon, MessageSquare, SquareCheckBig, BookOpenText, HeartHandshake } from "lucide-react";
import { RiMoneyDollarBoxLine, RiNotificationBadgeLine, RiSuitcase2Line } from "react-icons/ri";
import { BriefcaseSolid, CreditCardCheck, Notification } from "@mynaui/icons-react";
import { Paper } from "@mui/material";

export const IconMap = {
    "Activity": Activity,
    "Arrow Up Right": ArrowUpRight,
    "Bell": Bell,
    "Book Open": BookOpenText,
    "Book User": BookUser,
    "Book X": BookX,
    "Briefcase": BriefcaseBusinessIcon,
    "Calendar": Calendar,
    "Calculation": CalculateOutlined,
    "Case": BriefcaseBusiness,
    "Chain": Link,
    "Clipboard": Clipboard,
    "Clock": Clock,
    "Clock Alert": ClockAlert,
    "Cloud": Cloud,
    "Closing": CloseOutlined,
    "Code": Code,
    "Check": CheckCheck,
    "CreditCardCheck": CreditCardCheck,
    "Document": File,
    "DollarSign": DollarSign,
    "Edit": Edit,
    "Equal Approximate": EqualApproximately,
    "Eye": Eye,
    "File": Folder,
    "FilePlus2": FilePlus2,
    "File Stack": FileStack,
    "FileText": FileText,
    "Gavel": GavelRounded,
    "Gavel 2": GavelIcon,
    "HandShake": Handshake,
    "HeartHandshake": HeartHandshake,
    "Heart": Heart,
    "Home": Home,
    "Image": Image,
    "Insurance": ShieldCheck,
    "Lock": Lock,
    "MagnifyingGlass": Search,
    "Mail": Mail,
    "MapPin": MapPin,
    "Medical": MedicalInformationOutlined,
    "MessageCircle": MessageCircle,
    "Message Square": MessageSquare,
    "Money": Banknote,
    "MoreTime": MoreTime,
    "Notification": NotificationsActiveOutlined,
    "Other Fees": HandCoins,
    "Phone": Phone,
    "Receipt": ReceiptIcon,
    "Settings": Settings,
    "Shield": Shield,
    "ShoppingCart": ShoppingCart,
    "Square Check": SquareCheckBig,
    "Star": Star,
    "Swap": ArrowUpDown,
    "Tag": Tag,
    "Trash": Trash,
    "Truck": Truck,
    "User": User,
    "Users": Users,
    "User Search": UserSearch,
    "Updates": Update,
    "Video": Video
};